import { useContext, useCallback, useMemo } from "react"
import ListItemDropDown from "components/list-item-dropdown"
import { METRIC_OPTIONS } from "helpers/metrics/definitions"
import { useAnalytics } from "connected-components/analytics"
import { ASSET_VIEW_EVENTS } from "../../analytics/events"
import { BETA_CONTEXT } from "./context"

export default function BetaHeader() {
  const betaContext = useContext(BETA_CONTEXT)
  const { selectedMetricDisplay, setSelectedMetricDisplay } = betaContext

  const analytics = useAnalytics()

  const displayOptions = useMemo(() => METRIC_OPTIONS.beta.map(({ label, ...props }) => ({ primaryText: label, ...props })), [])

  const handleMetricDisplayChange = useCallback((metricDisplay) => {
    analytics.track(ASSET_VIEW_EVENTS.DISPLAY_METRIC_SELECTED, { metricDisplay })
    setSelectedMetricDisplay(metricDisplay)
  }, [analytics, setSelectedMetricDisplay])

  return <ListItemDropDown
    label="Display"
    value={selectedMetricDisplay}
    setValue={handleMetricDisplayChange}
    options={displayOptions}
    alignMenu="left"
    disablePortal
  />
}
